import { render, staticRenderFns } from "./UserClosing.vue?vue&type=template&id=43a523c4&"
import script from "./UserClosing.vue?vue&type=script&lang=js&"
export * from "./UserClosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports